// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__lw+3t","lds-spinner":"loader_lds-spinner__85QaI"};